import { Plus } from 'lucide-react';
import type { MouseEvent } from 'react';

type Props = {
  fieldName: string;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
};

export const GhostFieldItem = (props: Props) => {
  return (
    <div
      className="flex items-center gap-0.5 text-muted-foreground cursor-pointer border border-dune-300 rounded-full px-2.5 h-7 text-[13px] font-medium"
      onClick={props.onClick}
    >
      <Plus className="size-2.5 -ml-0.5" />
      {props.fieldName}
    </div>
  );
};
